<template>
  <div class="tabs-page">
    <div class="tabs-page-content">
<!--      <keep-alive>-->
<!--        <router-view :key="$route.fullPath" v-if="$route.meta.keepAlive" />-->
<!--      </keep-alive>-->
<!--      <router-view :key="$route.fullPath" v-if="!$route.meta.keepAlive" />-->
      <router-view />
    </div>
    <div :style="{'padding-bottom': isIPhoneXSMax ? '20px' : '10px'}" class="mainMenu">
      <div ref="allMenu" class="allMenu" :class="nowIndex === index ? 'active' : ''" v-for="(item, index) of menuList" :key="index" @click="toUrl(item, index)">
        <div style="margin-top: 3px">
          <img width="40%" :src="nowIndex === index ? item.activeImg : item.default" alt="">
        </div>
        <div>{{item.name}}</div>
      </div>
    </div>
<!--    <Tabbar v-model="active" @change="onTabChange" active-color="#000" inactive-color="#000">-->
<!--      <TabbarItem name="home" icon="wap-home">-->
<!--        <span>首页</span>-->
<!--        <template #icon="props">-->
<!--          <img :src="props.active ? require('../assets/1home-2@2x.png') : require('../assets/1home-1@2x.png')" />-->
<!--        </template>-->
<!--      </TabbarItem>-->
<!--      <TabbarItem name="market" icon="shop-collect">-->
<!--        <span>服务市场</span>-->
<!--        <template #icon="props">-->
<!--          <img :src="props.active ? require('../assets/2fwsc-2@2x.png') : require('../assets/2fwsc-1@2x.png')" />-->
<!--        </template>-->
<!--      </TabbarItem>-->
<!--      <TabbarItem name="trend" icon="gold-coin">-->
<!--        <span>行情走势</span>-->
<!--        <template #icon="props">-->
<!--          <img :src="props.active ? require('../assets/3new-2@2x.png') : require('../assets/3new-1@2x.png')" />-->
<!--        </template>-->
<!--      </TabbarItem>-->
<!--      <TabbarItem name="tradeLeads" icon="comment-circle">-->
<!--        <span>供求大厅</span>-->
<!--        <template #icon="props">-->
<!--          <img :src="props.active ? require('../assets/4fl-2@2x.png') : require('../assets/4fl-1@2x.png')" />-->
<!--        </template>-->
<!--      </TabbarItem>-->
<!--      <TabbarItem name="about" icon="manager">-->
<!--        <span>我的</span>-->
<!--        <template #icon="props">-->
<!--          <img :src="props.active ? require('../assets/5wd-2@2x.png') : require('../assets/5wd-1@2x.png')" />-->
<!--        </template>-->
<!--      </TabbarItem>-->
<!--    </Tabbar>-->
  </div>
</template>

<script>
  import {Tabbar, TabbarItem} from 'vant';
  let inter
  let timeout
  export default {
    components: {Tabbar, TabbarItem},
    data() {
      return {
        nowIndex: 0,
        isIPhoneXSMax: false,
        menuList: [
          {
            id: 0,
            name: '首页',
            default: require('../assets/1home-1@2x.png'),
            activeImg: require('../assets/1home-2@2x.png'),
            url: 'home'
          },
          {
            id: 0,
            name: '服务市场',
            default: require('../assets/2fwsc-1@2x.png'),
            activeImg: require('../assets/2fwsc-2@2x.png'),
            url: 'market'
          },
          {
            id: 1,
            name: '行情走势',
            default: require('../assets/3new-1@2x.png'),
            activeImg: require('../assets/3new-2@2x.png'),
            url: 'trend'
          },
          {
            id: 2,
            name: '供求大厅',
            default: require('../assets/4fl-1@2x.png'),
            activeImg: require('../assets/4fl-2@2x.png'),
            url: 'tradeLeads'
          },
          {
            id: 3,
            name: '我的',
            default: require('../assets/5wd-1@2x.png'),
            activeImg: require('../assets/5wd-2@2x.png'),
            url: 'about'
          }
        ],
        active: 'home'
      }
    },
    destroyed() {
      clearInterval(inter)
    },
    created() {
      this.isIPhoneXSMax = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && ((window.screen.width === 414 && window.screen.height === 896) || (window.screen.width === 375 && window.screen.height === 812))
      inter = setInterval(p => {
        if (this.$route.name === 'home') {
          window.sessionStorage.setItem('home', 0)
        }
        if (this.$route.name === 'market') {
          window.sessionStorage.setItem('nowIndex', 1)
        }
        if (this.$route.name === 'trend') {
          window.sessionStorage.setItem('nowIndex', 2)
        }
        if (this.$route.name === 'tradeLeads') {
          window.sessionStorage.setItem('nowIndex', 3)
        }
        if (this.$route.name === 'about') {
          window.sessionStorage.setItem('nowIndex', 4)
        }
        this.nowIndex = this.$route.query.goodName ? 1 : (parseInt(window.sessionStorage.getItem('nowIndex') || 0))
      }, 10)
    },
    watch: {
      // $route(val) {
      //   this.active = val.name;
      //   console.log(this.active)
      // }
    },
    methods: {
      toUrl (item, index) {
        if (this.nowIndex === index) {
          clearTimeout(timeout)
          timeout = setTimeout(p => {
            this.nowIndex = index
            window.sessionStorage.setItem('nowIndex', index)
            this.$router.push({
              path: item.url
            })
          }, 500)
        } else {
          this.nowIndex = index
          window.sessionStorage.setItem('nowIndex', index)
          this.$router.push({
            path: item.url
          })
        }
      },
      onTabChange(val) {
        this.$router.push(val);
      }
    }
  };
</script>

<style lang="less">
  .tabs-page {
	  height: 100%;

	  &-content {
		  height: 100%;
		  padding-bottom: 50px;
		  box-sizing: border-box;
		  overflow-y: auto;
      background-color: #f5f5f5;
	  }

    .van-tabbar-item__icon {
      margin-bottom: 0;
    }
    .van-tabbar-item__icon img {
      width: 32px;
      height: 32px;
    }
  }
  .mainPage {
    display: -webkit-flex; /* Safari */
    display: flex;
    flex-direction: column;
    /* background: url("../../../assets/indexBg.png") no-repeat;
    background-size: 100%;
    background-position-x: center; */
    background-color: #f3f4f6;
    height: 100%;
    overflow: scroll;
  }
  .topSearch {
    height: 60px;
    line-height: 60px;
    width: 96%;
    margin: 0 auto;
  }
  .main {
    flex: 1;
    width: 100%;
    margin: 0 auto 3% auto;
    overflow: scroll;
  }
  .mainMenu {
    background-color: #ffffff;
    display: flex;
    position: fixed;
    flex-direction: row;
    justify-content: space-between;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    color: #132033;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 6;
  }
  .mainMenu > div {
    flex: 1;
    text-align: center;
  }
  .mainMenu > div.active {
    //color: #0bc98b;
  }
  .menuActive {
    background-color: #efefef;
  }
  .mainMenu p:first-child>i {
    font-size: 1.4rem;
    font-weight: bolder;
  }
</style>
